import { makeStyles } from '@fluentui/react-components';
import React from 'react';
import { Outlet } from 'react-router-dom';
import { SiteHeader } from './SiteHeader';
import { withStyles } from "./withStyles";
import { Reading } from "../model/Reading";
import { slThemeLight } from "../slTheme";
import { TrendGraph } from './TrendGraph';
import { TrendArrow } from './TrendArrow';

export interface ThermReadingItemProps
{
    styles: Record<string, string>;
    description: string;
    readings: Reading[],
    targetWidth: number
}

export interface ThermReadingItemState
{
}

const useStyles = makeStyles(
    {
        readingContainer:
        {
            width: '110px',
            padding: '10pt',
            display: 'flex',
            flexDirection: 'column'
        },
        reading:
        {
            fontSize: slThemeLight.fontSizeHero800,
            lineHeight: slThemeLight.lineHeightHero800,
            fontWeight: slThemeLight.fontWeightBold,
            textAlign: 'center'
        },
        description:
        {
            textAlign: 'center'
        }
    });

export class ThermReadingItemWithoutStyles extends React.Component<ThermReadingItemProps, ThermReadingItemState>
{
    getTrendSlope(values: number[]): { slope: number, delta: number }
    {
        // first, get the contiguous slope
        let direction = 0;
        let last = 0;
        let i = 1;
        for (; i < values.length; i++)
        {
            const curDelta = values[i] - values[i - 1];

            if (curDelta == 0)
                continue;

            if (curDelta != direction)
            {
                last = i - 1;
                direction = curDelta > 0 ? 1 : curDelta < 0 ? -1 : 0;
            }
        }

        // max run length is 5 -- figure out what percentage of the values
        // our run comprises, then normalize around 5
        const run = ((values.length - i - last - 1) / values.length * 5);

        return {
            slope: ((values[i - 1] - values[last])) / run || 0, // avoid division by zero
            delta: Math.abs(values[i - 1] - values[last])
        };
    }

    render()
    {
        const lastReading = this.props.readings.length == 0 ? -1 : this.props.readings[this.props.readings.length - 1].ProcessData;
        const width = 110;
        const height = 60;
        const minTarget = 40;
        const maxTarget = 280;
        const values = this.props.readings.map(r => r.ProcessData);

        const { slope, delta } = this.getTrendSlope(values);

        return (
            <div className={this.props.styles.readingContainer}>
                <div className={this.props.styles.reading}>
                    {lastReading}<TrendArrow slope={slope} delta={delta}/>
                </div>
                <div>
                    <TrendGraph targetWidth={this.props.targetWidth} width={width} height={height} minTarget={minTarget} maxTarget={maxTarget} values={values}/>
                </div>
                <div className={this.props.styles.description}>{this.props.description}</div>
            </div>
        );
    }
}

export const ThermReadingItem = withStyles(useStyles, ThermReadingItemWithoutStyles);